module.exports = __webpack_public_path__ + "img/mgTip.7cdad6d3.gif";